import React, { useState } from 'react';
import { Tooltip } from 'antd';
import RenameModal from './RenameModal';
import { EditOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import './styles.css';

const DocumentTitle = ({ isMobile, showNav, toggleNav }) => {
    const documentInformation = useSelector((state) => state.editor.documentInformation);
    const templateData = useSelector((state) => state.editor.templateData);
    const isTemplateDocument = useSelector((state) => state.editor.isTemplateDocument);
    const isReadOnly = useSelector((state) => state.editor.isReadOnly);
    const [renameModalVisible, setRenameModalVisible] = useState(false);
    const name = isTemplateDocument ? (templateData ? templateData.name : "Template") : (documentInformation ? documentInformation.name : "New Board");

    return (
        <>
            <div className="document-title-container">
                <h1 className={`document-title-h1 ${isMobile ? 'mobile' : ''}`}>
                    {name}
                    {/* {!isReadOnly && (
                        <Tooltip title="Rename">
                            <span className={`document-title-edit-icon ${isMobile ? 'mobile' : ''}`}
                                onClick={() => setRenameModalVisible(true)}
                            >
                                <EditOutlined style={{ display: 'block', borderBottom: 'none', textDecoration: 'none' }} />
                            </span>
                        </Tooltip>
                    )} */}
                </h1>
                {isMobile && (
                    <button className={`title-toggle ${showNav ? 'open' : ''}`} aria-haspopup="true" aria-expanded={showNav} aria-label="Toggle navigation menu" onClick={(e) => { e.stopPropagation(); toggleNav && toggleNav(); }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M6 9L12 15L18 9" stroke="#202124" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                )}
            </div>
            <RenameModal
                visible={renameModalVisible}
                onClose={() => setRenameModalVisible(false)}
            />
        </>
    );
};

export default DocumentTitle;